/* =========================================================
   LSF COACHING+ — Moteur frontend complet
   DA Basic-Fit (orange + violet + crème) — Mobile-first
   ========================================================= */

(function () {
  'use strict';

  var root = document.getElementById('lsf-coaching');
  if (!root) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* 1. ÉTAT & PERSISTANCE */
  var STORAGE_KEY = 'lsf_coaching_data_v2';
  var DEFAULT_DATA = {
    sessions: [], planned: [], weights: [],
    goals: { weekly_visits: 3, target_weight: 70, kcal_target: 300 },
    xp: 0, badges: [], level: 'intermediaire'
  };

  function loadData() {
    try {
      var d = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!d) return clone(DEFAULT_DATA);
      d.sessions = d.sessions || [];
      d.planned = d.planned || [];
      d.weights = d.weights || [];
      d.goals = Object.assign({}, DEFAULT_DATA.goals, d.goals || {});
      d.xp = d.xp || 0;
      d.badges = d.badges || [];
      d.level = d.level || 'intermediaire';
      return d;
    } catch (e) { return clone(DEFAULT_DATA); }
  }
  function saveData(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  var DATA = loadData();

  /* 2. UTILITAIRES DATE */
  function isoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }
  function parseISO(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function todayKey() { return isoDate(new Date()); }
  var MONTHS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  var DAYNAMES = ['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'];

  /* 3. GAMIFICATION — XP / NIVEAUX / SÉRIES / BADGES */
  var RANKS = [
    { name: 'Débutant',     min: 0 },
    { name: 'Initié',       min: 150 },
    { name: 'Régulier',     min: 400 },
    { name: 'Motivé',       min: 800 },
    { name: 'Endurant',     min: 1400 },
    { name: 'Tonique',      min: 2200 },
    { name: 'Athlète',      min: 3200 },
    { name: 'Performer',    min: 4500 },
    { name: 'Élite',        min: 6000 },
    { name: 'Champion',     min: 8000 },
    { name: 'Légende LSF',  min: 11000 }
  ];
  function rankFor(xp) {
    var idx = 0;
    for (var i = 0; i < RANKS.length; i++) { if (xp >= RANKS[i].min) idx = i; }
    var current = RANKS[idx];
    var next = RANKS[idx + 1] || null;
    var lvl = idx + 1;
    var pct;
    if (next) {
      var into = xp - current.min, span = next.min - current.min;
      pct = Math.max(0, Math.min(100, Math.round((into / span) * 100)));
    } else { pct = 100; }
    return { level: lvl, name: current.name, next: next, pct: pct, xp: xp, toNext: next ? (next.min - xp) : 0 };
  }

  function currentStreak() {
    var set = {};
    DATA.sessions.forEach(function (s) { set[s.date] = true; });
    var streak = 0;
    var d = new Date();
    if (!set[isoDate(d)]) d.setDate(d.getDate() - 1);
    while (set[isoDate(d)]) { streak++; d.setDate(d.getDate() - 1); }
    return streak;
  }
  function maxStreak() {
    var dates = DATA.sessions.map(function (s) { return s.date; }).sort();
    var uniq = []; var seen = {};
    dates.forEach(function (dt) { if (!seen[dt]) { seen[dt] = 1; uniq.push(dt); } });
    var best = 0, run = 0, prev = null;
    uniq.forEach(function (dt) {
      if (prev) {
        var diff = Math.round((parseISO(dt) - parseISO(prev)) / 86400000);
        run = diff === 1 ? run + 1 : 1;
      } else run = 1;
      if (run > best) best = run;
      prev = dt;
    });
    return best;
  }

  function totalKcal() { return DATA.sessions.reduce(function (a, s) { return a + (s.calories || 0); }, 0); }
  function totalMinutes() { return DATA.sessions.reduce(function (a, s) { return a + (s.duration || 0); }, 0); }

  var BADGES = [
    { id: 'first',     icon: '🔥', name: 'Première séance',     desc: 'Termine ta 1re séance EMS',           code: 'BIENVENUE10',  test: function () { return DATA.sessions.length >= 1; } },
    { id: 'streak3',   icon: '⚡', name: 'Série de 3',           desc: '3 jours d\'affilée',                   code: 'SERIE3',       test: function () { return maxStreak() >= 3; } },
    { id: 'streak7',   icon: '🏆', name: 'Semaine parfaite',     desc: '7 jours d\'affilée',                   code: 'PARFAIT15',    test: function () { return maxStreak() >= 7; } },
    { id: 'sess10',    icon: '💪', name: '10 séances',           desc: 'Cumule 10 séances',                    code: 'CLUB10',       test: function () { return DATA.sessions.length >= 10; } },
    { id: 'sess25',    icon: '🥇', name: '25 séances',           desc: 'Cumule 25 séances',                    code: 'PRO25',        test: function () { return DATA.sessions.length >= 25; } },
    { id: 'kcal1000',  icon: '🌋', name: '1000 kcal',            desc: 'Brûle 1000 kcal au total',             code: 'BRULE20',      test: function () { return totalKcal() >= 1000; } },
    { id: 'early',     icon: '🌅', name: 'Lève-tôt',             desc: 'Une séance avant 8h',                  code: 'MATIN10',      test: function () { return DATA.sessions.some(function (s) { return s.ts && new Date(s.ts).getHours() < 8; }); } },
    { id: 'level5',    icon: '👑', name: 'Niveau Tonique',       desc: 'Atteins le rang Tonique',              code: 'TONIQUE25',    test: function () { return rankFor(DATA.xp).level >= 6; } },
    { id: 'weight',    icon: '⚖️', name: 'Suivi assidu',         desc: 'Enregistre 5 pesées',                  code: 'SUIVI10',      test: function () { return DATA.weights.length >= 5; } }
  ];

  function checkBadges() {
    var newly = [];
    BADGES.forEach(function (b) {
      if (DATA.badges.indexOf(b.id) === -1 && b.test()) { DATA.badges.push(b.id); newly.push(b); }
    });
    if (newly.length) {
      saveData(DATA);
      newly.forEach(function (b, i) {
        setTimeout(function () {
          toast('🎉 Badge débloqué : ' + b.name + ' — code <strong>' + b.code + '</strong>');
        }, 400 + i * 1600);
      });
    }
    return newly;
  }

  function awardXp(amount) {
    var before = rankFor(DATA.xp).level;
    DATA.xp += amount;
    saveData(DATA);
    var after = rankFor(DATA.xp).level;
    if (after > before) {
      setTimeout(function () { toast('🆙 Niveau ' + after + ' atteint : ' + rankFor(DATA.xp).name + ' !'); }, 200);
    }
  }

  /* 4. TOAST */
  var toastTimer = null;
  function toast(html) {
    var t = document.getElementById('lsf-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'lsf-toast';
      t.className = 'lsf-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3800);
  }

  /* 5. NAVIGATION SPA */
  function showScreen(name) {
    $$('.lsf-screen').forEach(function (s) { s.classList.toggle('lsf-screen--active', s.dataset.screen === name); });
    $$('.lsf-tab').forEach(function (t) { t.classList.toggle('is-active', t.dataset.target === name); });
    window.scrollTo({ top: 0, behavior: 'auto' });
    if (name === 'calendar') renderCalendar();
    if (name === 'progress') renderProgress();
    if (name === 'home') { renderWeekStrip(); renderHomeGami(); renderPlannedCard(); }
  }
  $$('.lsf-tab').forEach(function (tab) {
    tab.addEventListener('click', function () { if (tab.dataset.target) showScreen(tab.dataset.target); });
  });
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-go]');
    if (el) { e.preventDefault(); showScreen(el.dataset.go); }
  });

  /* 6. DRAWERS + STEPPERS */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    $$('.lsf-drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
  }
  root.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { openDrawer(opener.dataset.openDrawer); if (opener.dataset.openDrawer === 'lsf-drawer-plan') buildPlanList(); return; }
    if (e.target.closest('[data-close-drawer]')) { closeDrawers(); return; }
    if (e.target.classList.contains('lsf-drawer') && e.target.classList.contains('is-open')) closeDrawers();
  });

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.lsf-stepper__btn');
    if (!btn) return;
    var stepper = btn.closest('.lsf-stepper');
    var valEl = $('.lsf-stepper__val', stepper);
    var min = +stepper.dataset.min, max = +stepper.dataset.max;
    var size = +(stepper.dataset.stepSize || 1);
    var dir = +btn.dataset.step;
    var cur = +valEl.textContent;
    cur = Math.max(min, Math.min(max, cur + dir * size));
    valEl.textContent = cur;
  });

  var saveGoalsBtn = $('#lsf-save-goals');
  if (saveGoalsBtn) {
    saveGoalsBtn.addEventListener('click', function () {
      $$('.lsf-stepper').forEach(function (st) {
        var key = st.dataset.stepper;
        var v = +$('.lsf-stepper__val', st).textContent;
        if (key === 'weekly_visits') DATA.goals.weekly_visits = v;
        if (key === 'target_weight') DATA.goals.target_weight = v;
        if (key === 'kcal_target') DATA.goals.kcal_target = v;
      });
      saveData(DATA);
      closeDrawers();
      renderWeekStrip(); renderHomeGami();
      toast('✅ Objectifs enregistrés');
    });
  }

  /* 7. WEEK STRIP + GAMIFICATION HOME */
  function renderWeekStrip() {
    var strip = $('#lsf-weekstrip');
    if (!strip) return;
    var set = {}; DATA.sessions.forEach(function (s) { set[s.date] = true; });
    var planned = {}; DATA.planned.forEach(function (p) { planned[p.date] = true; });
    var today = new Date();
    var dow = (today.getDay() + 6) % 7;
    var monday = new Date(today); monday.setDate(today.getDate() - dow);
    var tk = isoDate(today);
    var html = '', done = 0;
    for (var i = 0; i < 7; i++) {
      var d = new Date(monday); d.setDate(monday.getDate() + i);
      var key = isoDate(d);
      var isToday = key === tk, isDone = set[key] === true, isPlan = planned[key] === true;
      if (isDone) done++;
      var mark = '';
      if (isDone) mark = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      else if (isPlan) mark = '<span class="lsf-day__dot lsf-day__dot--plan"></span>';
      else if (isToday) mark = '<span class="lsf-day__dot"></span>';
      html += '<div class="lsf-day' + (isToday ? ' is-today' : '') + (isDone ? ' is-done' : '') + '">' +
        '<div class="lsf-day__name">' + DAYNAMES[i] + '</div>' +
        '<div class="lsf-day__num">' + d.getDate() + '</div>' +
        '<div class="lsf-day__mark">' + mark + '</div></div>';
    }
    strip.innerHTML = html;
    var goalDone = $('#lsf-goal-done'); if (goalDone) goalDone.textContent = String(done);
    var goalTotal = $('#lsf-goal-total'); if (goalTotal) goalTotal.textContent = String(DATA.goals.weekly_visits);
  }

  function renderHomeGami() {
    var r = rankFor(DATA.xp);
    var lvlNum = $('#lsf-lvl-num'); if (lvlNum) lvlNum.textContent = r.level;
    var lvlName = $('#lsf-lvl-name'); if (lvlName) lvlName.textContent = r.name;
    var lvlXp = $('#lsf-lvl-xp'); if (lvlXp) lvlXp.textContent = r.next ? (r.xp + ' / ' + r.next.min + ' XP') : (r.xp + ' XP · max');
    var bar = $('#lsf-lvl-bar'); if (bar) bar.style.width = r.pct + '%';
    var streakEl = $('#lsf-home-streak'); if (streakEl) streakEl.textContent = currentStreak();
    var xpEl = $('#lsf-home-xp'); if (xpEl) xpEl.textContent = DATA.xp;
  }

  function renderPlannedCard() {
    var card = $('#lsf-planned-card');
    if (!card) return;
    var future = DATA.planned.filter(function (p) { return p.date >= todayKey(); }).sort(function (a, b) { return a.date < b.date ? -1 : 1; });
    if (!future.length) { card.hidden = true; card.innerHTML = ''; return; }
    var p = future[0];
    var isToday = p.date === todayKey();
    var dateObj = parseISO(p.date);
    var label = isToday ? "Aujourd'hui" : (DAYNAMES[(dateObj.getDay() + 6) % 7] + ' ' + dateObj.getDate() + ' ' + MONTHS[dateObj.getMonth()].toLowerCase());
    card.hidden = false;
    card.innerHTML =
      '<div class="lsf-planned__tag">SÉANCE PLANIFIÉE</div>' +
      '<div class="lsf-planned__row">' +
        '<div><h3 class="lsf-planned__name">' + p.name + '</h3>' +
        '<p class="lsf-planned__date">' + label + '</p></div>' +
        (isToday
          ? '<button type="button" class="lsf-btn lsf-btn--gold lsf-planned__cta" data-launch="' + p.sessionId + '">Démarrer</button>'
          : '<span class="lsf-planned__lock">🔒</span>') +
      '</div>';
  }

  /* 8. CALENDRIER COMPLET */
  var calCursor = new Date();
  function renderCalendar() {
    var grid = $('#lsf-cal-grid'); if (!grid) return;
    var set = {}; DATA.sessions.forEach(function (s) { set[s.date] = true; });
    var planned = {}; DATA.planned.forEach(function (p) { planned[p.date] = true; });
    var monthEl = $('#lsf-cal-month');
    if (monthEl) monthEl.textContent = MONTHS[calCursor.getMonth()] + ' ' + calCursor.getFullYear();
    var first = new Date(calCursor.getFullYear(), calCursor.getMonth(), 1);
    var startOffset = (first.getDay() + 6) % 7;
    var daysInMonth = new Date(calCursor.getFullYear(), calCursor.getMonth() + 1, 0).getDate();
    var tk = todayKey();
    var html = '';
    for (var i = 0; i < startOffset; i++) html += '<span class="lsf-cal__cell lsf-cal__cell--empty"></span>';
    for (var day = 1; day <= daysInMonth; day++) {
      var d = new Date(calCursor.getFullYear(), calCursor.getMonth(), day);
      var key = isoDate(d);
      var cls = 'lsf-cal__cell';
      if (set[key]) cls += ' is-done';
      else if (planned[key]) cls += ' is-planned';
      if (key === tk) cls += ' is-today';
      html += '<span class="' + cls + '">' + day + '</span>';
    }
    grid.innerHTML = html;
    var totalEl = $('#lsf-cal-total'); if (totalEl) totalEl.textContent = DATA.sessions.length;
    var kcalEl = $('#lsf-cal-kcal'); if (kcalEl) kcalEl.textContent = totalKcal();
    var streakEl = $('#lsf-cal-streak'); if (streakEl) streakEl.textContent = maxStreak();
    var hist = $('#lsf-cal-history');
    if (hist) {
      var recent = DATA.sessions.slice().sort(function (a, b) { return a.date < b.date ? 1 : -1; }).slice(0, 12);
      if (!recent.length) hist.innerHTML = '<p class="lsf-empty">Aucune séance pour le moment. Lance ta première séance EMS&nbsp;!</p>';
      else hist.innerHTML = recent.map(function (s) {
        var d = parseISO(s.date);
        return '<div class="lsf-histrow"><div class="lsf-histrow__icon">🔥</div>' +
          '<div class="lsf-histrow__body"><strong>' + (s.name || 'Séance EMS') + '</strong>' +
          '<span>' + d.getDate() + ' ' + MONTHS[d.getMonth()].toLowerCase() + ' · ' + (s.duration || 0) + ' min · ' + (s.calories || 0) + ' kcal</span></div>' +
          '<div class="lsf-histrow__xp">+' + (s.xp || 0) + ' XP</div></div>';
      }).join('');
    }
  }
  var prevBtn = $('#lsf-cal-prev'); if (prevBtn) prevBtn.addEventListener('click', function () { calCursor.setMonth(calCursor.getMonth() - 1); renderCalendar(); });
  var nextBtn = $('#lsf-cal-next'); if (nextBtn) nextBtn.addEventListener('click', function () { calCursor.setMonth(calCursor.getMonth() + 1); renderCalendar(); });

  /* 9. ÉCRAN PROGRÈS */
  $$('.lsf-tabs__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = btn.dataset.progTab;
      $$('.lsf-tabs__btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      $$('.lsf-prog-pane').forEach(function (p) { p.classList.toggle('is-active', p.dataset.progPane === tab); });
    });
  });

  function renderProgress() {
    var s = $('#lsf-stat-sessions'); if (s) s.textContent = DATA.sessions.length;
    var k = $('#lsf-stat-kcal'); if (k) k.textContent = totalKcal();
    var m = $('#lsf-stat-minutes'); if (m) m.textContent = totalMinutes();
    var st = $('#lsf-stat-streak'); if (st) st.textContent = currentStreak();
    var now = $('#lsf-weight-now');
    var last = DATA.weights.slice().sort(function (a, b) { return a.date < b.date ? -1 : 1; }).pop();
    if (now) now.textContent = last ? (last.kg + ' kg') : '— kg';
    var target = $('#lsf-weight-target'); if (target) target.textContent = DATA.goals.target_weight + ' kg';
    var bWrap = $('#lsf-badges');
    if (bWrap) {
      bWrap.innerHTML = BADGES.map(function (b) {
        var unlocked = DATA.badges.indexOf(b.id) !== -1;
        return '<div class="lsf-badge' + (unlocked ? ' is-unlocked' : '') + '">' +
          '<div class="lsf-badge__icon">' + (unlocked ? b.icon : '🔒') + '</div>' +
          '<div class="lsf-badge__name">' + b.name + '</div>' +
          '<div class="lsf-badge__desc">' + b.desc + '</div>' +
          (unlocked
            ? '<div class="lsf-badge__code">Code : <strong>' + b.code + '</strong></div>'
            : '<div class="lsf-badge__locked">À débloquer</div>') +
          '</div>';
      }).join('');
    }
  }

  var weightBtn = $('#lsf-weight-log');
  if (weightBtn) {
    weightBtn.addEventListener('click', function () {
      var v = prompt('Votre poids actuel (kg) :');
      if (v === null) return;
      var kg = parseFloat(String(v).replace(',', '.'));
      if (isNaN(kg) || kg < 30 || kg > 250) { toast('⚠️ Poids invalide'); return; }
      DATA.weights.push({ date: todayKey(), kg: Math.round(kg * 10) / 10 });
      saveData(DATA);
      checkBadges();
      renderProgress();
      toast('⚖️ Poids enregistré : ' + kg + ' kg');
    });
  }

  /* 10. CATALOGUE DE SÉANCES EMS (style Basic Fit) */
  function ex(name, muscle, consigne, deb, inter, avc, work, rest, rounds) {
    return {
      name: name, muscle: muscle, consigne: consigne,
      ems: { debutant: { lvl: deb[0], hz: deb[1] }, intermediaire: { lvl: inter[0], hz: inter[1] }, avance: { lvl: avc[0], hz: avc[1] } },
      work: work, rest: rest, rounds: rounds || 1
    };
  }
  function warm(name, consigne, sec) { return { name: name, muscle: 'Échauffement', consigne: consigne, ems: null, work: sec, rest: 0, rounds: 1, phase: 'warmup' }; }
  function cool(name, consigne, sec) { return { name: name, muscle: 'Retour au calme', consigne: consigne, ems: null, work: sec, rest: 0, rounds: 1, phase: 'cooldown' }; }

  var SESSIONS = {
    complet: {
      id: 'complet', name: 'RENFO COMPLET — FULL BODY', icon: '⭐', duration: 28,
      focus: 'Full body', intensity: 'Modulable', kcal: 320, xp: 120,
      blocks: [
        warm('Activation respiratoire', 'Debout, inspirez 4s par le nez, expirez 6s. Relâchez les épaules. Placez vos électrodes (ceinture abdos + brassards) sur peau propre et sèche.', 40),
        warm('Mobilité dynamique', 'Cercles de bras, rotations du bassin, montées de genoux lentes pour réveiller le corps.', 60),
        ex('Gainage planche', 'Sangle abdominale', 'En planche sur les avant-bras, dos droit, gainez le ventre. Synchronisez la contraction EMS avec votre expiration.', [10,50], [16,65], [24,75], 30, 20, 3),
        ex('Crunch isométrique', 'Abdos grands droits', 'Allongé, épaules décollées, maintenez la contraction. Sur l\'impulsion EMS, contractez davantage les abdos.', [9,50], [15,60], [22,75], 25, 15, 3),
        ex('Curl biceps', 'Biceps', 'Bras le long du corps, montez les avant-bras lentement (4s) puis descendez (4s) en suivant l\'impulsion EMS.', [8,45], [14,55], [20,70], 30, 15, 3),
        ex('Squat tempo', 'Quadriceps & fessiers', 'Descendez en squat sur 4s, remontez sur 2s. Gardez le buste droit, poussez dans les talons.', [11,50], [17,60], [25,75], 35, 20, 3),
        ex('Fentes alternées', 'Fessiers & jambes', 'Une fente avant à droite puis à gauche. Genou aligné avec la cheville. EMS synchronisée à la poussée.', [10,50], [16,60], [23,72], 30, 20, 2),
        ex('Pont fessier', 'Fessiers & ischios', 'Allongé, pieds au sol, montez le bassin et serrez les fessiers en haut sur l\'impulsion EMS.', [10,50], [16,62], [24,75], 30, 15, 3),
        cool('Étirement chaîne postérieure', 'Assis, jambes tendues, ramenez doucement le buste vers les jambes. Respiration lente. EMS désactivée.', 45),
        cool('Étirement & retour au calme', 'Étirez bras, quadriceps et abdos. Buvez de l\'eau. Félicitations, séance terminée !', 45)
      ]
    },
    reveil: {
      id: 'reveil', name: 'RÉVEIL ÉNERGIQUE', icon: '🌅', duration: 20,
      focus: 'Activation douce', intensity: 'Faible', kcal: 160, xp: 70,
      blocks: [
        warm('Respiration & posture', 'Debout, grandissez-vous. Inspirez bras en haut, expirez bras le long du corps. Placez vos électrodes.', 40),
        warm('Réveil articulaire', 'Cercles de chevilles, poignets, épaules et nuque en douceur.', 50),
        ex('Gainage léger', 'Sangle abdominale', 'Planche sur les genoux, dos droit. Contraction douce synchronisée à l\'EMS.', [8,45], [12,55], [16,60], 25, 20, 2),
        ex('Curl biceps réveil', 'Biceps', 'Mouvement lent et contrôlé pour activer les bras en douceur.', [7,45], [11,50], [15,60], 25, 20, 2),
        ex('Demi-squat', 'Jambes & fessiers', 'Petite amplitude, tempo lent, on réveille les jambes sans forcer.', [8,45], [12,55], [17,62], 25, 20, 2),
        cool('Étirement complet', 'Étirez tout le corps en respirant profondément. Belle journée à vous !', 50)
      ]
    },
    brule: {
      id: 'brule', name: 'BRÛLE-GRAISSES', icon: '🔥', duration: 30,
      focus: 'Cardio + EMS', intensity: 'Haute', kcal: 380, xp: 150,
      blocks: [
        warm('Échauffement cardio', 'Montées de genoux et talons-fesses légers pendant 1 min pour élever le rythme cardiaque.', 60),
        warm('Mobilité express', 'Fentes marchées et cercles de bras pour préparer les articulations.', 45),
        ex('Squats sautés (ou tempo)', 'Jambes & fessiers', 'Squat puis petit saut. Débutant : squat tempo sans saut. EMS en synchronisation.', [10,55], [18,70], [27,80], 30, 15, 4),
        ex('Mountain climbers', 'Abdos & cardio', 'En planche, ramenez les genoux alternativement vers la poitrine, rythme soutenu.', [10,55], [17,68], [25,80], 30, 15, 4),
        ex('Fentes dynamiques', 'Fessiers & jambes', 'Alternez les fentes avec énergie. Gardez le gainage.', [11,55], [18,68], [26,78], 30, 15, 3),
        ex('Gainage dynamique', 'Sangle abdominale', 'Planche avec passage avant-bras / mains. Contraction maximale sur l\'EMS.', [11,55], [18,68], [26,80], 30, 20, 3),
        cool('Récupération cardio', 'Marchez sur place, ralentissez la respiration jusqu\'au calme.', 50),
        cool('Étirements complets', 'Étirez jambes, fessiers et abdos. Hydratez-vous bien.', 45)
      ]
    },
    abdos: {
      id: 'abdos', name: 'TONIFICATION ABDOS', icon: '🎯', duration: 25,
      focus: 'Sangle abdominale', intensity: 'Moyenne', kcal: 240, xp: 100,
      blocks: [
        warm('Activation du transverse', 'Allongé, rentrez le nombril vers la colonne sans bloquer la respiration. Placez la ceinture abdos EMS.', 45),
        ex('Crunch classique', 'Grands droits', 'Décollez les épaules, soufflez en montant. Contraction renforcée sur l\'EMS.', [9,55], [16,65], [23,78], 30, 15, 3),
        ex('Gainage planche', 'Sangle profonde', 'Planche avant-bras, bassin gainé, ne creusez pas le dos.', [10,55], [17,68], [25,78], 35, 20, 3),
        ex('Gainage latéral', 'Obliques', 'Sur le côté, en appui sur l\'avant-bras, hanches hautes. Changez de côté à chaque round.', [9,55], [16,65], [23,75], 25, 15, 4),
        ex('Relevés de jambes', 'Bas des abdos', 'Allongé, montez les jambes tendues puis descendez lentement sans toucher le sol.', [9,55], [15,65], [22,76], 30, 15, 3),
        cool('Étirement abdos', 'À plat ventre, poussez sur les mains pour étirer la sangle (posture du cobra). Respirez.', 45)
      ]
    },
    recup: {
      id: 'recup', name: 'RÉCUPÉRATION ACTIVE', icon: '🌿', duration: 20,
      focus: 'Étirements EMS', intensity: 'Très faible', kcal: 110, xp: 60,
      blocks: [
        warm('Respiration profonde', 'Allongé ou assis, respirez lentement. Mode EMS massage/relaxation faible.', 60),
        ex('Étirement guidé dos', 'Dos & lombaires', 'Posture de l\'enfant, relâchez le dos. L\'EMS en mode doux favorise la récupération.', [6,30], [9,35], [12,40], 40, 15, 2),
        ex('Étirement jambes', 'Ischios & mollets', 'Jambes tendues, ramenez doucement les orteils vers vous.', [6,30], [9,35], [12,40], 40, 15, 2),
        ex('Relâchement épaules', 'Trapèzes & nuque', 'Roulez doucement les épaules, relâchez la nuque. EMS basse fréquence.', [6,30], [8,35], [11,40], 35, 15, 2),
        cool('Cohérence cardiaque', 'Inspirez 5s, expirez 5s pendant 1 min. Vous êtes prêt(e) à récupérer pleinement.', 60)
      ]
    },
    jambes: {
      id: 'jambes', name: 'JAMBES & FESSIERS', icon: '🦵', duration: 25,
      focus: 'Bas du corps', intensity: 'Moyenne', kcal: 260, xp: 100,
      blocks: [
        warm('Activation bas du corps', 'Montées de genoux, balancier de jambes et flexions douces pour réveiller cuisses et fessiers. Placez les électrodes cuisses + fessiers.', 45),
        ex('Squat profond', 'Quadriceps & fessiers', 'Descendez bas, dos droit, poussez dans les talons. Contraction EMS à la remontée.', [10,50], [16,62], [24,75], 35, 20, 3),
        ex('Fentes arrière', 'Fessiers & ischios', 'Reculez une jambe en fente, genou vers le sol, alternez. Gardez le buste droit.', [10,50], [16,60], [23,72], 30, 20, 3),
        ex('Pont fessier', 'Fessiers', 'Bassin vers le haut, serrez fort les fessiers en haut sur l\'impulsion EMS.', [11,50], [17,62], [25,75], 30, 15, 3),
        ex('Mollets debout', 'Mollets', 'Montez sur la pointe des pieds lentement, redescendez en contrôle.', [8,45], [13,55], [18,65], 25, 15, 2),
        cool('Étirement jambes', 'Étirez quadriceps, ischios et mollets. Respiration lente.', 45)
      ]
    },
    bras: {
      id: 'bras', name: 'BRAS & ÉPAULES', icon: '💪', duration: 22,
      focus: 'Haut du corps', intensity: 'Moyenne', kcal: 210, xp: 90,
      blocks: [
        warm('Réveil des bras', 'Cercles de bras, rotations d\'épaules. Placez les brassards EMS biceps + triceps.', 40),
        ex('Curl biceps', 'Biceps', 'Montez les avant-bras lentement, serrez en haut sur l\'EMS, descendez en contrôle.', [9,50], [15,60], [22,72], 30, 15, 3),
        ex('Extension triceps', 'Triceps', 'Bras au-dessus de la tête, tendez les avant-bras vers le haut. Contraction EMS en extension.', [9,50], [15,60], [22,72], 30, 15, 3),
        ex('Élévations latérales', 'Épaules', 'Montez les bras tendus sur les côtés à hauteur d\'épaules, lentement.', [8,45], [13,55], [19,68], 25, 15, 3),
        cool('Étirement bras & épaules', 'Étirez biceps, triceps et épaules en douceur.', 40)
      ]
    },
    dos: {
      id: 'dos', name: 'DOS & POSTURE', icon: '🧍', duration: 22,
      focus: 'Dos & posture', intensity: 'Moyenne', kcal: 200, xp: 90,
      blocks: [
        warm('Mobilité dorsale', 'Roulez les épaules, ouvrez la cage thoracique, étirez la nuque. Placez les électrodes dorsales.', 45),
        ex('Superman', 'Lombaires & dos', 'À plat ventre, décollez bras et jambes, tenez. Contraction EMS du dos.', [9,45], [15,55], [21,68], 25, 20, 3),
        ex('Tirage coudes', 'Grand dorsal', 'Debout, tirez les coudes vers l\'arrière en serrant les omoplates.', [9,50], [15,60], [22,70], 30, 15, 3),
        ex('Gainage dorsal', 'Dos & posture', 'En planche dorsale (table inversée), gainez le dos et les fessiers.', [9,50], [15,60], [21,70], 25, 20, 2),
        cool('Étirement dos', 'Posture de l\'enfant puis étirement du cou. Relâchez.', 45)
      ]
    },
    hiit: {
      id: 'hiit', name: 'HIIT EXPRESS', icon: '⚡', duration: 18,
      focus: 'Cardio intense', intensity: 'Très haute', kcal: 240, xp: 110,
      blocks: [
        warm('Échauffement express', 'Montées de genoux rapides et talons-fesses pendant 45s.', 45),
        ex('Burpees (ou tempo)', 'Full body', 'Burpee complet ; débutant : squat + planche sans saut. Rythme maximal.', [11,55], [19,72], [28,82], 25, 15, 4),
        ex('Squats sautés', 'Jambes', 'Squat puis saut explosif. Réception souple.', [11,55], [18,70], [27,80], 25, 15, 4),
        ex('Mountain climbers', 'Abdos & cardio', 'Genoux vers la poitrine en planche, le plus vite possible.', [10,55], [17,68], [25,80], 25, 15, 4),
        cool('Retour au calme', 'Marchez sur place, ralentissez la respiration.', 45)
      ]
    },
    core: {
      id: 'core', name: 'CORE INTENSE', icon: '🎯', duration: 22,
      focus: 'Abdos profonds', intensity: 'Haute', kcal: 220, xp: 95,
      blocks: [
        warm('Activation du transverse', 'Respiration ventrale, rentrez le nombril. Placez la ceinture abdos.', 40),
        ex('Planche longue', 'Gainage complet', 'Planche avant-bras, corps gainé, ne creusez pas le dos. Tenez.', [10,55], [17,68], [25,78], 40, 20, 3),
        ex('Russian twists', 'Obliques', 'Assis, buste incliné, tournez le buste de gauche à droite.', [9,55], [16,65], [23,75], 30, 15, 3),
        ex('Relevés de jambes', 'Bas des abdos', 'Allongé, montez/descendez les jambes tendues sans toucher le sol.', [9,55], [15,65], [22,76], 30, 15, 3),
        ex('Gainage latéral', 'Obliques', 'Sur le côté, hanches hautes, changez de côté à chaque round.', [9,50], [16,62], [23,74], 25, 15, 2),
        cool('Étirement abdos', 'Posture du cobra puis respiration profonde.', 40)
      ]
    },
    pecs: {
      id: 'pecs', name: 'PECTORAUX & BUSTE', icon: '🫁', duration: 20,
      focus: 'Pectoraux', intensity: 'Moyenne', kcal: 210, xp: 90,
      blocks: [
        warm('Échauffement buste', 'Cercles de bras et ouvertures de poitrine. Placez les électrodes pectoraux.', 40),
        ex('Pompes (ou genoux)', 'Pectoraux', 'Pompes classiques ou sur les genoux, descente contrôlée.', [10,50], [16,62], [24,74], 30, 20, 3),
        ex('Écartés', 'Pectoraux', 'Bras tendus sur les côtés, ramenez les mains devant la poitrine en serrant.', [9,50], [15,60], [22,70], 30, 15, 3),
        ex('Pompes serrées', 'Pectoraux & triceps', 'Mains rapprochées, coudes près du corps.', [10,50], [16,62], [23,72], 25, 20, 2),
        cool('Étirement poitrine', 'Ouvrez la poitrine contre un mur, étirez les bras.', 40)
      ]
    },
    fessiers: {
      id: 'fessiers', name: 'FESSIERS BÉTON', icon: '🍑', duration: 25,
      focus: 'Fessiers', intensity: 'Moyenne', kcal: 250, xp: 100,
      blocks: [
        warm('Activation fessiers', 'Pas chassés, ouvertures de hanche et squats légers. Placez les électrodes fessiers.', 45),
        ex('Hip thrust', 'Fessiers', 'Dos calé, montez le bassin, serrez fort les fessiers en haut.', [11,50], [17,62], [25,75], 30, 15, 4),
        ex('Fentes bulgares (ou avant)', 'Fessiers & cuisses', 'Une jambe en arrière surélevée, descendez. Alternez par round.', [10,50], [16,60], [23,72], 30, 20, 3),
        ex('Kickback', 'Moyen fessier', 'À quatre pattes, montez la jambe tendue vers l\'arrière en serrant le fessier.', [9,50], [15,60], [22,70], 25, 15, 3),
        ex('Squat sumo', 'Fessiers & adducteurs', 'Pieds larges, pointes vers l\'extérieur, descendez bas.', [10,50], [16,62], [24,74], 30, 15, 2),
        cool('Étirement fessiers', 'Étirement pigeon et figure 4 de chaque côté.', 45)
      ]
    },
    gainage: {
      id: 'gainage', name: 'GAINAGE TOTAL', icon: '🪵', duration: 20,
      focus: 'Stabilité & centre', intensity: 'Moyenne', kcal: 190, xp: 85,
      blocks: [
        warm('Préparation gainage', 'Respiration et activation profonde du centre. Placez la ceinture abdos.', 40),
        ex('Planche', 'Centre', 'Planche avant-bras, corps aligné, gainez tout le centre.', [10,50], [16,62], [24,75], 40, 20, 3),
        ex('Planche dynamique', 'Centre & épaules', 'Passez d\'avant-bras à mains et inversement, gardez le bassin stable.', [10,55], [16,65], [24,76], 30, 20, 2),
        ex('Hollow hold', 'Abdos profonds', 'Allongé, bas du dos plaqué, décollez épaules et jambes, tenez.', [9,55], [15,65], [22,74], 30, 15, 3),
        cool('Relâchement', 'Étirement doux du dos et respiration lente.', 40)
      ]
    }
  };

  /* 11. LECTEUR DE SÉANCE EMS GUIDÉE (style Basic Fit) */
  var player = { session: null, level: DATA.level, steps: [], idx: 0, phase: 'idle', remaining: 0, timer: null, paused: false };

  function buildSteps(session, level) {
    var steps = [];
    session.blocks.forEach(function (b) {
      var rounds = b.rounds || 1;
      for (var r = 1; r <= rounds; r++) {
        steps.push({
          name: b.name, muscle: b.muscle, consigne: b.consigne,
          ems: b.ems ? b.ems[level] : null,
          work: b.work, rest: b.rest, round: r, rounds: rounds,
          isWarm: b.phase === 'warmup', isCool: b.phase === 'cooldown'
        });
      }
    });
    return steps;
  }

  function beep(freq, dur) {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      if (!player.audio) player.audio = new Ctx();
      var ctx = player.audio;
      var osc = ctx.createOscillator(), gain = ctx.createGain();
      osc.frequency.value = freq || 880; osc.type = 'sine';
      gain.gain.setValueAtTime(0.001, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + (dur || 0.18));
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(); osc.stop(ctx.currentTime + (dur || 0.18));
    } catch (e) {}
  }
  function vibrate(ms) { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {} }

  function ensurePlayerDom() {
    if (document.getElementById('lsf-player')) return;
    var el = document.createElement('div');
    el.id = 'lsf-player';
    el.className = 'lsf-player';
    el.innerHTML =
      '<div class="lsf-player__top">' +
        '<button type="button" class="lsf-player__close" id="lsf-player-close" aria-label="Quitter">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '<div class="lsf-player__title" id="lsf-player-title">Séance</div>' +
        '<div class="lsf-player__step" id="lsf-player-step">1/1</div>' +
      '</div>' +
      '<div class="lsf-player__progress"><span id="lsf-player-progbar"></span></div>' +
      '<div class="lsf-player__body">' +
        '<div class="lsf-player__phase" id="lsf-player-phase">PRÉPARATION</div>' +
        '<h2 class="lsf-player__ex" id="lsf-player-ex">—</h2>' +
        '<div class="lsf-player__muscle" id="lsf-player-muscle">—</div>' +
        '<div class="lsf-player__ring"><svg viewBox="0 0 120 120"><circle class="lsf-ring__bg" cx="60" cy="60" r="54"></circle><circle class="lsf-ring__fg" id="lsf-ring-fg" cx="60" cy="60" r="54"></circle></svg>' +
          '<div class="lsf-player__time" id="lsf-player-time">0</div></div>' +
        '<div class="lsf-player__ems" id="lsf-player-ems"></div>' +
        '<p class="lsf-player__consigne" id="lsf-player-consigne"></p>' +
        '<div class="lsf-player__next" id="lsf-player-next"></div>' +
      '</div>' +
      '<div class="lsf-player__controls">' +
        '<button type="button" class="lsf-pctrl" id="lsf-player-prev" aria-label="Précédent"><svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M6 6h2v12H6zM9.5 12l8.5 6V6z"></path></svg></button>' +
        '<button type="button" class="lsf-pctrl lsf-pctrl--main" id="lsf-player-play" aria-label="Pause/Reprendre"><svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><rect x="6" y="5" width="4" height="14"></rect><rect x="14" y="5" width="4" height="14"></rect></svg></button>' +
        '<button type="button" class="lsf-pctrl" id="lsf-player-next-btn" aria-label="Suivant"><svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M16 6h2v12h-2zM6 6l8.5 6L6 18z"></path></svg></button>' +
      '</div>';
    document.body.appendChild(el);
    document.getElementById('lsf-player-close').addEventListener('click', closePlayer);
    document.getElementById('lsf-player-play').addEventListener('click', togglePause);
    document.getElementById('lsf-player-next-btn').addEventListener('click', function () { nextStep(true); });
    document.getElementById('lsf-player-prev').addEventListener('click', prevStep);
  }

  var RING_LEN = 2 * Math.PI * 54;

  function startSession(sessionId, level) {
    var session = SESSIONS[sessionId];
    if (!session) return;
    ensurePlayerDom();
    player.session = session;
    player.level = level || DATA.level || 'intermediaire';
    player.steps = buildSteps(session, player.level);
    player.idx = 0;
    document.getElementById('lsf-player').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.getElementById('lsf-player-title').textContent = session.name;
    var fg = document.getElementById('lsf-ring-fg');
    fg.style.strokeDasharray = RING_LEN; fg.style.strokeDashoffset = 0;
    renderStep();
  }

  function renderStep() {
    var s = player.steps[player.idx];
    if (!s) return finishSession();
    player.phase = 'work';
    player.remaining = s.work;
    player.paused = false;
    document.getElementById('lsf-player-step').textContent = (player.idx + 1) + '/' + player.steps.length;
    document.getElementById('lsf-player-progbar').style.width = Math.round((player.idx / player.steps.length) * 100) + '%';
    var phaseLabel = s.isWarm ? 'ÉCHAUFFEMENT' : (s.isCool ? 'RETOUR AU CALME' : 'EXERCICE');
    var phaseEl = document.getElementById('lsf-player-phase');
    phaseEl.textContent = phaseLabel;
    phaseEl.className = 'lsf-player__phase' + (s.isWarm ? ' is-warm' : (s.isCool ? ' is-cool' : ' is-work'));
    document.getElementById('lsf-player-ex').textContent = s.name + (s.rounds > 1 ? '  ·  Série ' + s.round + '/' + s.rounds : '');
    document.getElementById('lsf-player-muscle').textContent = s.muscle;
    document.getElementById('lsf-player-consigne').textContent = s.consigne;
    var emsEl = document.getElementById('lsf-player-ems');
    if (s.ems) {
      emsEl.style.display = '';
      emsEl.innerHTML = '<span class="lsf-ems__zap">⚡ EMS</span>' +
        '<span class="lsf-ems__lvl">Intensité <strong>' + s.ems.lvl + '</strong>/30</span>' +
        '<span class="lsf-ems__hz">' + s.ems.hz + ' Hz</span>';
    } else { emsEl.style.display = 'none'; emsEl.innerHTML = ''; }
    var next = player.steps[player.idx + 1];
    document.getElementById('lsf-player-next').innerHTML = next
      ? '<span>SUIVANT</span><strong>' + next.name + '</strong>'
      : '<span>DERNIER EFFORT</span><strong>Fin de séance 🎉</strong>';
    setPlayIcon(false);
    beep(660, 0.12); vibrate(60);
    tick(true);
  }

  function setPlayIcon(paused) {
    var btn = document.getElementById('lsf-player-play');
    btn.innerHTML = paused
      ? '<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M8 5v14l11-7z"></path></svg>'
      : '<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><rect x="6" y="5" width="4" height="14"></rect><rect x="14" y="5" width="4" height="14"></rect></svg>';
  }

  function tick(initial) {
    clearTimeout(player.timer);
    var s = player.steps[player.idx];
    if (!s) return finishSession();
    var totalForPhase = player.phase === 'work' ? s.work : s.rest;
    document.getElementById('lsf-player-time').textContent = player.remaining;
    var fg = document.getElementById('lsf-ring-fg');
    var ratio = totalForPhase ? (player.remaining / totalForPhase) : 0;
    fg.style.strokeDashoffset = RING_LEN * (1 - ratio);
    fg.style.stroke = player.phase === 'rest' ? 'var(--lsf-violet)' : 'var(--lsf-orange)';
    if (!initial) {
      if (player.remaining <= 3 && player.remaining > 0) { beep(player.remaining === 1 ? 990 : 740, 0.1); vibrate(40); }
    }
    if (player.remaining <= 0) {
      if (player.phase === 'work' && s.rest > 0) {
        player.phase = 'rest';
        player.remaining = s.rest;
        var pe = document.getElementById('lsf-player-phase');
        pe.textContent = 'RÉCUPÉRATION';
        pe.className = 'lsf-player__phase is-rest';
        document.getElementById('lsf-player-ex').textContent = 'Récupération';
        beep(440, 0.2); vibrate([60, 40, 60]);
        player.timer = setTimeout(stepTick, 1000);
        return;
      } else { nextStep(false); return; }
    }
    player.timer = setTimeout(stepTick, 1000);
  }
  function stepTick() { if (player.paused) return; player.remaining--; tick(false); }

  function nextStep(manual) {
    clearTimeout(player.timer);
    player.idx++;
    if (player.idx >= player.steps.length) return finishSession();
    renderStep();
  }
  function prevStep() {
    clearTimeout(player.timer);
    if (player.idx > 0) player.idx--;
    renderStep();
  }
  function togglePause() {
    player.paused = !player.paused;
    setPlayIcon(player.paused);
    if (!player.paused) { player.timer = setTimeout(stepTick, 1000); }
    else clearTimeout(player.timer);
  }

  function finishSession() {
    clearTimeout(player.timer);
    var session = player.session;
    var pl = document.getElementById('lsf-player');
    var kcal = session.kcal || 200;
    var xp = session.xp || 80;
    DATA.sessions.push({ date: todayKey(), sessionId: session.id, name: session.name, duration: session.duration, calories: kcal, xp: xp, ts: Date.now() });
    DATA.planned = DATA.planned.filter(function (p) { return !(p.date === todayKey() && p.sessionId === session.id); });
    DATA.level = player.level;
    saveData(DATA);
    awardXp(xp);
    checkBadges();
    var r = rankFor(DATA.xp);
    pl.querySelector('.lsf-player__body').innerHTML =
      '<div class="lsf-finish">' +
        '<div class="lsf-finish__check">🎉</div>' +
        '<h2 class="lsf-finish__title">Séance terminée !</h2>' +
        '<p class="lsf-finish__sub">' + session.name + '</p>' +
        '<div class="lsf-finish__stats">' +
          '<div><strong>' + session.duration + '</strong><span>minutes</span></div>' +
          '<div><strong>' + kcal + '</strong><span>kcal</span></div>' +
          '<div><strong>+' + xp + '</strong><span>XP</span></div>' +
        '</div>' +
        '<div class="lsf-finish__level">Niveau ' + r.level + ' · ' + r.name + ' — série de ' + currentStreak() + ' 🔥</div>' +
        '<button type="button" class="lsf-btn lsf-btn--gold" id="lsf-finish-close">Revenir à l\'accueil</button>' +
      '</div>';
    document.getElementById('lsf-player-progbar').style.width = '100%';
    pl.querySelector('.lsf-player__controls').style.display = 'none';
    beep(880, 0.25); setTimeout(function () { beep(1100, 0.3); }, 200); vibrate([100, 50, 100, 50, 160]);
    document.getElementById('lsf-finish-close').addEventListener('click', function () { closePlayer(); showScreen('home'); });
  }

  function closePlayer() {
    clearTimeout(player.timer);
    var pl = document.getElementById('lsf-player');
    if (pl) pl.classList.remove('is-open');
    document.body.style.overflow = '';
    renderWeekStrip(); renderHomeGami(); renderPlannedCard();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-launch]');
    if (btn) {
      e.preventDefault();
      var seg = document.querySelector('.lsf-levelseg .is-active');
      var lvl = btn.dataset.level || (seg ? seg.dataset.level : DATA.level);
      startSession(btn.dataset.launch, lvl);
    }
  });

  /* 12. SÉLECTEUR DE NIVEAU */
  root.addEventListener('click', function (e) {
    var seg = e.target.closest('.lsf-levelseg [data-level]');
    if (!seg) return;
    $$('.lsf-levelseg [data-level]').forEach(function (b) { b.classList.toggle('is-active', b === seg); });
    DATA.level = seg.dataset.level; saveData(DATA);
  });

  /* 13. PLANIFICATION */
  function buildPlanList() {
    var wrap = $('#lsf-planlist');
    if (!wrap) return;
    wrap.innerHTML = Object.keys(SESSIONS).map(function (key) {
      var s = SESSIONS[key];
      return '<button type="button" class="lsf-planitem" data-plan-session="' + s.id + '" data-plan-name="' + s.name + '">' +
        '<span class="lsf-planitem__icon">' + s.icon + '</span>' +
        '<span class="lsf-planitem__body"><strong>' + s.name + '</strong><small>' + s.duration + ' min · ' + s.focus + '</small></span>' +
        '</button>';
    }).join('');
  }
  var planSel = { sessionId: null, name: null, day: 0 };
  root.addEventListener('click', function (e) {
    var item = e.target.closest('[data-plan-session]');
    if (item) {
      planSel.sessionId = item.dataset.planSession;
      planSel.name = item.dataset.planName;
      $$('[data-plan-session]').forEach(function (b) { b.classList.toggle('is-active', b === item); });
      var step2 = $('#lsf-plan-step2');
      if (step2) {
        step2.style.display = 'block';
        var grid = $('#lsf-day-grid');
        var html = '';
        for (var i = 0; i < 7; i++) {
          var d = new Date(); d.setDate(d.getDate() + i);
          var lbl = i === 0 ? "Auj." : DAYNAMES[(d.getDay() + 6) % 7];
          html += '<button type="button" class="lsf-daypick' + (i === 0 ? ' is-active' : '') + '" data-day="' + i + '">' +
            '<span>' + lbl + '</span><strong>' + d.getDate() + '</strong></button>';
        }
        grid.innerHTML = html;
      }
    }
    var dp = e.target.closest('[data-day]');
    if (dp) {
      planSel.day = +dp.dataset.day;
      $$('[data-day]').forEach(function (b) { b.classList.toggle('is-active', b === dp); });
    }
  });
  var confirmPlan = $('#lsf-confirm-plan');
  if (confirmPlan) {
    confirmPlan.addEventListener('click', function () {
      if (!planSel.sessionId) { toast('Choisissez une séance'); return; }
      var d = new Date(); d.setDate(d.getDate() + planSel.day);
      var key = isoDate(d);
      DATA.planned = DATA.planned.filter(function (p) { return p.date !== key; });
      DATA.planned.push({ date: key, sessionId: planSel.sessionId, name: planSel.name });
      saveData(DATA);
      closeDrawers();
      renderWeekStrip(); renderPlannedCard(); renderCalendar();
      toast('📅 Séance planifiée !');
      var step2 = $('#lsf-plan-step2'); if (step2) step2.style.display = 'none';
    });
  }

  /* 14. INIT */
  $$('.lsf-levelseg [data-level]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.level === DATA.level); });
  renderWeekStrip();
  renderHomeGami();
  renderPlannedCard();
  checkBadges();
})();
